import { forwardRef, type SelectHTMLAttributes } from "react";

import { cn } from "@/lib/cn";

import { renderFieldLabel } from "./fieldLabel";

type Option = { value: string; label: string };

type SelectProps = SelectHTMLAttributes<HTMLSelectElement> & {
  label: string;
  options: Option[];
  error?: string;
};

export const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { label, options, error, className, id, ...props },
  ref,
) {
  const selectId = id ?? props.name ?? label.toLowerCase().replace(/\s+/g, "-");

  return (
    <label className="flex flex-col gap-1.5" htmlFor={selectId}>
      {renderFieldLabel(label)}
      <select
        ref={ref}
        id={selectId}
        className={cn(
          "h-11 rounded-xl border bg-surface-raised px-3.5 text-sm text-ink",
          "focus:border-brand focus:outline-none focus:ring-2 focus:ring-brand/20",
          error ? "border-danger" : "border-line",
          className,
        )}
        {...props}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {error ? <span className="text-xs text-danger">{error}</span> : null}
    </label>
  );
});
